import axios from 'axios'
import {getAccessToken} from "./getAccessToken.js";

const auth0AccessToken = getAccessToken();
const instance = axios.create({
    headers: {
        'authorization': `Bearer ${auth0AccessToken}`,
        'Content-Type': 'application/json'
    }
});

export default instance
